import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { API } from '../config';
import { tr } from '../til';


const inputStyle = {
  padding: '10px 12px',
  border: '1px solid #ddd',
  borderRadius: '8px',
  fontSize: '14px'
};

const smallBtn = {
  padding: '6px 12px',
  background: '#eef1f7',
  color: '#1a1a2e',
  border: '1px solid #ddd',
  borderRadius: '8px',
  fontSize: '12px',
  cursor: 'pointer'
};

const LETTERS = ['a', 'b', 'c', 'd'];

const emptyQuestion = () => ({
  question: '',
  option_a: '',
  option_b: '',
  option_c: '',
  option_d: '',
  correct_answer: 'a'
});

// Savollar ro'yxatini tahrirlash — yangi test yaratishda ham,
// mavjudini o'zgartirishda ham ishlatiladi.
function QuestionBuilder({ questions, setQuestions }) {
  const update = (index, field, value) => {
    setQuestions(prev => prev.map((q, i) => (i === index ? { ...q, [field]: value } : q)));
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
        <h4 style={{ margin: 0, fontSize: '15px' }}>{tr("Savollar ({soni})", { soni: questions.length })}</h4>
        <button onClick={() => setQuestions(prev => [...prev, emptyQuestion()])} style={smallBtn}>
          + {tr("Savol qo'shish")}
        </button>
      </div>

      {questions.map((q, i) => (
        <div
          key={i}
          style={{
            border: '1px solid #eee',
            borderRadius: '10px',
            padding: '16px',
            marginBottom: '12px',
            background: '#fafbfc'
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '13px', color: '#666' }}>{i + 1}- {tr("savol")}</strong>
            {questions.length > 1 && (
              <button
                onClick={() => setQuestions(prev => prev.filter((_, x) => x !== i))}
                style={{ ...smallBtn, color: '#c93636' }}
              >
                {tr("O'chirish")}
              </button>
            )}
          </div>

          <input
            type="text"
            placeholder={tr("Savol matni")}
            value={q.question}
            onChange={e => update(i, 'question', e.target.value)}
            style={{ ...inputStyle, width: '100%', marginBottom: '10px', boxSizing: 'border-box' }}
          />

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
            {LETTERS.map(letter => (
              <label
                key={letter}
                title={q.correct_answer === letter ? tr("To'g'ri javob") : tr("To'g'ri javob deb belgilash")}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  background: q.correct_answer === letter ? '#e9f9ed' : '#fff',
                  border: `1px solid ${q.correct_answer === letter ? '#2d8a2d' : '#ddd'}`,
                  borderRadius: '8px',
                  padding: '4px 10px'
                }}
              >
                <input
                  type="radio"
                  checked={q.correct_answer === letter}
                  onChange={() => update(i, 'correct_answer', letter)}
                />
                <span style={{ fontWeight: '600', color: '#888', textTransform: 'uppercase' }}>{letter}</span>
                <input
                  type="text"
                  placeholder={tr("{toUpperCase} varianti", { toUpperCase: letter.toUpperCase() })}
                  value={q[`option_${letter}`]}
                  onChange={e => update(i, `option_${letter}`, e.target.value)}
                  style={{ flex: 1, minWidth: 0, border: 'none', outline: 'none', padding: '6px 0', fontSize: '14px', background: 'transparent' }}
                />
              </label>
            ))}
          </div>
        </div>
      ))}

      <p style={{ color: '#999', fontSize: '12px', marginTop: 0 }}>
        {tr("Yashil bilan belgilangan variant — to'g'ri javob.")}
      </p>
    </div>
  );
}

// Bo'sh savollarni tashlab, qolganlarini tekshiradi.
// { list } yoki { error } qaytaradi.
const prepareQuestions = (questions) => {
  const filled = questions.filter(q =>
    q.question.trim() || q.option_a.trim() || q.option_b.trim() ||
    q.option_c.trim() || q.option_d.trim()
  );

  if (filled.length === 0) {
    return { error: tr("Kamida bitta savol qo'shing — savolsiz test ilovada ochilmaydi") };
  }

  for (let i = 0; i < filled.length; i++) {
    const q = filled[i];
    if (!q.question.trim() || !q.option_a.trim() || !q.option_b.trim() ||
        !q.option_c.trim() || !q.option_d.trim()) {
      return { error: tr("{n}-savol to'liq to'ldirilmagan (savol matni va 4 ta variant)", { n: i + 1 }) };
    }
  }

  return { list: filled };
};

const CATEGORIES = [
  { value: 'korrupsiya', label: tr("Korrupsiyaga qarshi") },
  { value: 'yo\'l_xavfsizligi', label: tr("Yo'l xavfsizligi") },
  { value: 'etika', label: tr("Kasbiy etika") },
  { value: 'psixologiya', label: tr("Psixologiya") }
];

function Tests() {
  const [tests, setTests] = useState([]);
  const [title, setTitle] = useState('');
  const [category, setCategory] = useState('');
  const [questions, setQuestions] = useState([emptyQuestion()]);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [saving, setSaving] = useState(false);

  const [editing, setEditing] = useState(null);
  const [editError, setEditError] = useState('');
  const [editSaving, setEditSaving] = useState(false);

  const token = localStorage.getItem('token');

  const loadTests = useCallback(() => {
    axios.get(`${API}/tests`, { headers: { authorization: token } })
      .then(res => setTests(res.data));
  }, [token]);

  useEffect(() => {
    loadTests();
  }, [loadTests]);

  const createTest = async () => {
    setError('');
    setSuccess('');

    if (!title || !category) {
      setError(tr("Test nomi va kategoriyani tanlang"));
      return;
    }

    const prepared = prepareQuestions(questions);
    if (prepared.error) {
      setError(prepared.error);
      return;
    }

    setSaving(true);
    try {
      const res = await axios.post(`${API}/tests/create`, {
        title, category, questions: prepared.list
      }, { headers: { authorization: token } });

      setSuccess(tr("\"{title}\" yaratildi — {question_count} ta savol bilan.", { title, question_count: res.data.question_count }));
      setTitle('');
      setCategory('');
      setQuestions([emptyQuestion()]);
      loadTests();
    } catch (err) {
      setError(err.response?.data?.error || tr("Test yaratilmadi. Qaytadan urinib ko'ring."));
    } finally {
      setSaving(false);
    }
  };

  const openEdit = async (test) => {
    setError('');
    setSuccess('');
    setEditError('');
    try {
      const res = await axios.get(`${API}/tests/${test.id}`, {
        headers: { authorization: token }
      });
      const loaded = (res.data.questions || []).map(q => ({
        question: q.question || '',
        option_a: q.option_a || '',
        option_b: q.option_b || '',
        option_c: q.option_c || '',
        option_d: q.option_d || '',
        correct_answer: String(q.correct_answer || 'a').toLowerCase()
      }));
      setEditing({
        id: test.id,
        title: test.title,
        category: test.category,
        result_count: test.result_count,
        questions: loaded.length > 0 ? loaded : [emptyQuestion()]
      });
    } catch {
      setError(tr("Testni yuklab bo'lmadi."));
    }
  };

  const saveEdit = async () => {
    setEditError('');

    if (!editing.title || !editing.category) {
      setEditError(tr("Test nomi va kategoriyani tanlang"));
      return;
    }

    const prepared = prepareQuestions(editing.questions);
    if (prepared.error) {
      setEditError(prepared.error);
      return;
    }

    setEditSaving(true);
    try {
      const res = await axios.put(`${API}/tests/${editing.id}`, {
        title: editing.title,
        category: editing.category,
        questions: prepared.list
      }, { headers: { authorization: token } });

      setSuccess(tr("\"{title}\" yangilandi — {question_count} ta savol.", { title: editing.title, question_count: res.data.question_count }));
      setEditing(null);
      loadTests();
    } catch (err) {
      setEditError(err.response?.data?.error || tr("Saqlanmadi. Qaytadan urinib ko'ring."));
    } finally {
      setEditSaving(false);
    }
  };

  const deleteTest = async (test) => {
    setError('');
    setSuccess('');

    const warning = test.result_count > 0
      ? '\n\n' + tr("DIQQAT: bu testni {n} ta xodim topshirgan. Ularning natijalari ham o'chadi.", { n: test.result_count })
      : '';

    if (!window.confirm(tr("\"{title}\" o'chirilsinmi?{warning}\n\nBu amalni qaytarib bo'lmaydi.", { title: test.title, warning }))) return;

    try {
      await axios.delete(`${API}/tests/${test.id}`, { headers: { authorization: token } });
      setSuccess(tr("\"{title}\" o'chirildi.", { title: test.title }));
      loadTests();
    } catch (err) {
      setError(err.response?.data?.error || tr("O'chirib bo'lmadi."));
    }
  };

  return (
    <div>
      <h2 style={{ marginBottom: '24px', fontSize: '22px' }}>{tr("Testlar")}</h2>

      <div style={{ background: '#fff', borderRadius: '12px', padding: '24px', boxShadow: '0 1px 8px rgba(0,0,0,0.06)', marginBottom: '24px' }}>
        <h3 style={{ marginBottom: '16px', fontSize: '16px' }}>{tr("Yangi test")}</h3>

        <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', marginBottom: '20px' }}>
          <input
            type="text"
            placeholder={tr("Test nomi")}
            value={title}
            onChange={e => setTitle(e.target.value)}
            style={{ ...inputStyle, flex: 1, minWidth: '200px' }}
          />
          <select
            value={category}
            onChange={e => setCategory(e.target.value)}
            style={{ ...inputStyle, minWidth: '180px' }}
          >
            <option value="">{tr("Kategoriya tanlang")}</option>
            {CATEGORIES.map(c => (
              <option key={c.value} value={c.value}>{c.label}</option>
            ))}
          </select>
        </div>

        <div style={{ borderTop: '1px solid #f0f0f0', paddingTop: '16px' }}>
          <QuestionBuilder questions={questions} setQuestions={setQuestions} />
        </div>

        {error && (
          <div style={{ background: '#ffeaea', color: '#c93636', padding: '10px 12px', borderRadius: '8px', fontSize: '13px', marginBottom: '12px' }}>
            {error}
          </div>
        )}
        {success && (
          <div style={{ background: '#e9f9ed', color: '#2d8a2d', padding: '10px 12px', borderRadius: '8px', fontSize: '13px', marginBottom: '12px' }}>
            {success}
          </div>
        )}

        <button
          onClick={createTest}
          disabled={saving}
          style={{
            padding: '10px 24px',
            background: saving ? '#888' : '#1a1a2e',
            color: '#fff',
            border: 'none',
            borderRadius: '8px',
            fontSize: '14px',
            width: '100%',
            cursor: saving ? 'default' : 'pointer'
          }}
        >
          {saving ? tr("Yaratilmoqda...") : tr("Testni yaratish")}
        </button>
      </div>

      <div style={{ background: '#fff', borderRadius: '12px', padding: '24px', boxShadow: '0 1px 8px rgba(0,0,0,0.06)' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
          <thead>
            <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
              <th style={{ textAlign: 'left', padding: '10px 8px', color: '#888', fontWeight: '500' }}>{tr("Nomi")}</th>
              <th style={{ textAlign: 'left', padding: '10px 8px', color: '#888', fontWeight: '500' }}>{tr("Kategoriya")}</th>
              <th style={{ textAlign: 'center', padding: '10px 8px', color: '#888', fontWeight: '500' }}>{tr("Savollar")}</th>
              <th style={{ textAlign: 'center', padding: '10px 8px', color: '#888', fontWeight: '500' }}>{tr("Topshirilgan")}</th>
              <th style={{ textAlign: 'left', padding: '10px 8px', color: '#888', fontWeight: '500' }}>{tr("Sana")}</th>
              <th style={{ textAlign: 'right', padding: '10px 8px', color: '#888', fontWeight: '500' }}>{tr("Amallar")}</th>
            </tr>
          </thead>
          <tbody>
            {tests.map(test => (
              <tr key={test.id} style={{ borderBottom: '1px solid #f9f9f9' }}>
                <td style={{ padding: '10px 8px', fontWeight: '500' }}>{test.title}</td>
                <td style={{ padding: '10px 8px' }}>
                  <span style={{ background: '#e6f0ff', color: '#4f8ef7', padding: '3px 10px', borderRadius: '20px', fontSize: '12px' }}>
                    {test.category}
                  </span>
                </td>
                <td style={{ padding: '10px 8px', textAlign: 'center' }}>
                  <span style={{
                    background: test.question_count > 0 ? '#e9f9ed' : '#ffeaea',
                    color: test.question_count > 0 ? '#2d8a2d' : '#c93636',
                    padding: '3px 10px',
                    borderRadius: '20px',
                    fontSize: '12px'
                  }}>
                    {test.question_count > 0 ? test.question_count : tr("bo'sh")}
                  </span>
                </td>
                <td style={{ padding: '10px 8px', textAlign: 'center', color: '#888' }}>{test.result_count}</td>
                <td style={{ padding: '10px 8px', color: '#888' }}>
                  {new Date(test.created_at).toLocaleDateString('uz-UZ')}
                </td>
                <td style={{ padding: '10px 8px', textAlign: 'right', whiteSpace: 'nowrap' }}>
                  <button onClick={() => openEdit(test)} style={{ ...smallBtn, marginRight: '6px' }}>
                    {tr("Tahrirlash")}
                  </button>
                  <button onClick={() => deleteTest(test)} style={{ ...smallBtn, color: '#c93636' }}>
                    {tr("O'chirish")}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {tests.length === 0 && (
          <p style={{ color: '#999', fontSize: '14px', textAlign: 'center', margin: '20px 0 0' }}>
            {tr("Hali test yaratilmagan.")}
          </p>
        )}
      </div>

      {editing && (
        <div
          onClick={() => setEditing(null)}
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', zIndex: 100
          }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{
              background: '#fff', borderRadius: '12px', padding: '24px',
              width: '100%', maxWidth: '680px', maxHeight: '88vh', overflowY: 'auto'
            }}
          >
            <h3 style={{ marginTop: 0, marginBottom: '16px', fontSize: '18px' }}>{tr("Testni tahrirlash")}</h3>

            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', marginBottom: '16px' }}>
              <input
                type="text"
                placeholder={tr("Test nomi")}
                value={editing.title}
                onChange={e => setEditing({ ...editing, title: e.target.value })}
                style={{ ...inputStyle, flex: 1, minWidth: '200px' }}
              />
              <select
                value={editing.category}
                onChange={e => setEditing({ ...editing, category: e.target.value })}
                style={{ ...inputStyle, minWidth: '180px' }}
              >
                <option value="">{tr("Kategoriya tanlang")}</option>
                {CATEGORIES.map(c => (
                  <option key={c.value} value={c.value}>{c.label}</option>
                ))}
              </select>
            </div>

            {editing.result_count > 0 && (
              <div style={{ background: '#fff8e6', color: '#8a6d2d', padding: '10px 12px', borderRadius: '8px', fontSize: '13px', marginBottom: '16px' }}>
                {tr("Bu testni {result_count} ta xodim topshirgan. Savollarni o'zgartirsangiz, ularning eski ballari o'zgarmaydi.", { result_count: editing.result_count })}
              </div>
            )}

            <div style={{ borderTop: '1px solid #f0f0f0', paddingTop: '16px' }}>
              <QuestionBuilder
                questions={editing.questions}
                setQuestions={updater => setEditing(prev => ({
                  ...prev,
                  questions: typeof updater === 'function' ? updater(prev.questions) : updater
                }))}
              />
            </div>

            {editError && (
              <div style={{ background: '#ffeaea', color: '#c93636', padding: '10px 12px', borderRadius: '8px', fontSize: '13px', marginBottom: '12px' }}>
                {editError}
              </div>
            )}

            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
              <button onClick={() => setEditing(null)} style={{ ...smallBtn, padding: '10px 20px', fontSize: '14px' }}>
                {tr("Bekor qilish")}
              </button>
              <button
                onClick={saveEdit}
                disabled={editSaving}
                style={{
                  padding: '10px 24px',
                  background: editSaving ? '#888' : '#1a1a2e',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '14px',
                  cursor: editSaving ? 'default' : 'pointer'
                }}
              >
                {editSaving ? tr("Saqlanmoqda...") : tr("Saqlash")}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Tests;
